import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DecodedTokenI } from '../../../views/shared/interfaces/decoded-token.interface';
import { UserI } from '../../../views/shared/interfaces/user.interface';
import { StorageService } from '../storage/storage';

@Injectable({
  providedIn: 'root',
})
export class Session {
  private readonly loggedInUser: Subject<UserI | null> = new Subject();
  private readonly storageService = inject(StorageService);

  constructor() {}

  addLoggedInUser(user: UserI) {
    this.loggedInUser.next(user);
  }

  getLoggedInUser$() {
    return this.loggedInUser.asObservable();
  }

  getDecodedToken(): DecodedTokenI {
    return JSON.parse(atob(this.storageService.accessToken?.split('.')[1]!));
  }
}
